/** Query keys for the dial session contacts table. */
export const dialSessionContactKeys = {
  all: ["dial-session-contacts"],
  lists: () => [...dialSessionContactKeys.all, "list"],
  list: ({ dialSessionId = null } = {}) => [
    ...dialSessionContactKeys.lists(),
    { dialSessionId },
  ],
};
